import { weekendInfoService } from "../../services/api";

interface WeekendInfo {
  name: string;
  text: string;
}

// Cache per weekendId
const infoCache: Record<number, WeekendInfo[]> = {};

export async function loadWeekendInfo(weekendId: number): Promise<void> {
  try {
    const response = await weekendInfoService.getAll(weekendId);
    const list: WeekendInfo[] = response.data;
    infoCache[weekendId] = list.sort((a, b) => a.name.localeCompare(b.name));
  } catch (error) {
    console.error(`Failed to load info for weekend ${weekendId}:`, error);
    infoCache[weekendId] = [];
  }
}

export function getWeekendInfoByName(weekendId: number, name: string): string {
  return infoCache[weekendId]?.find((item) => item.name === name)?.text ?? "";
}

export function getWeekendInfo(weekendId: number): WeekendInfo[] {
  return structuredClone(infoCache[weekendId] ?? []);
}

export async function createWeekendInfo(
  weekendId: number,
  data: { name: string; text: string }
) {
  try {
    const response = await weekendInfoService.create(weekendId, data);
    await loadWeekendInfo(weekendId);
    return response.data;
  } catch (error) {
    console.error("Failed to create weekend info:", error);
    if (error.response?.status === 409)
      throw new Error("Запис з такою назвою вже існує");
    throw new Error("Не вдалося створити запис");
  }
}

export async function updateWeekendInfo(
  weekendId: number,
  name: string,
  data: { text: string }
) {
  try {
    const response = await weekendInfoService.update(weekendId, name, data);
    await loadWeekendInfo(weekendId);
    return response.data;
  } catch (error) {
    console.error("Failed to update weekend info:", error);
    if (error.response?.status === 404) throw new Error("Запис не знайдено");
    throw new Error("Не вдалося оновити запис");
  }
}

export async function deleteWeekendInfo(weekendId: number, name: string) {
  try {
    const response = await weekendInfoService.delete(weekendId, name);
    await loadWeekendInfo(weekendId);
    return response.data;
  } catch (error) {
    console.error("Failed to delete weekend info:", error);
    if (error.response?.status === 404) throw new Error("Запис не знайдено");
    throw new Error("Не вдалося видалити запис");
  }
}